import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Global 401 handler — if session expired, redirect to login page once.
// This prevents "Uncaught runtime errors" overlay when components forget try/catch.
let _redirecting = false;
api.interceptors.response.use(
  (resp) => resp,
  (err) => {
    const status = err?.response?.status;
    const url = err?.config?.url || "";
    // Skip redirect for auth probing endpoints so AuthContext handles them itself
    const isAuthProbe = url.includes("/auth/me") || url.includes("/me/permissions") || url.includes("/auth/login");
    if (status === 401 && !isAuthProbe && !_redirecting) {
      const onLoginPage = typeof window !== "undefined" && window.location.pathname.startsWith("/login");
      if (!onLoginPage) {
        _redirecting = true;
        try { window.location.assign("/login"); } catch { /* noop */ }
      }
    }
    return Promise.reject(err);
  },
);

export default api;

export function formatApiError(err) {
  const detail = err?.response?.data?.detail;
  if (detail == null) return err?.message || "Bir hata oluştu";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .join(" ");
  }
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
